// Analytics Configuration
// Add your actual tracking IDs here

export const analyticsConfig = {
  // Google Analytics 4 Measurement ID
  // Get this from: https://analytics.google.com/ > Admin > Property > Data Streams
  googleAnalytics: {
    measurementId: 'G-75G1CM57E4' // Your GA4 ID
  },
  
  // Facebook Pixel IDs - Multiple pixels for different tracking purposes
  // Get this from: https://business.facebook.com/events_manager
  facebook: {
    pixelIds: [
      '1468081884304281', // Chassie Hall - shop.bohostyleco.com via Shopify
      '1515206913262294', // BohoStyleCo Ecommerce Tracking - bohostyleco.com via Google Analytics
      '1745373566162048'  // Boho Style Company's pixel - bohostyleco.com via Meta Ads Manager
    ]
  },
  
  // Google Ads Conversion Tracking
  // Get this from: https://ads.google.com/aw/conversions
  googleAds: {
    conversionId: 'YOUR_GOOGLE_ADS_CONVERSION_ID', // Format: AW-XXXXXXXXXX
    conversionLabel: 'YOUR_CONVERSION_LABEL'
  }
};

// Environment-specific settings - use function to avoid module-level window access during SSR
export const getIsProduction = () => typeof window !== 'undefined' ? window.location.hostname !== 'localhost' : true;
// Lazy evaluation - only computed when accessed, not at module load time
let _isProduction: boolean | null = null;
export const isProduction = () => {
  if (_isProduction === null) {
    _isProduction = getIsProduction();
  }
  return _isProduction;
};
export const getEnableTracking = () => getIsProduction(); // Lazy evaluation - only computed when called

// Enhanced ecommerce item format
export interface AnalyticsItem {
  item_id: string;
  item_name: string;
  item_category: string;
  item_variant?: string;
  price: number;
  quantity: number;
  currency?: string;
}